import { Grid, Stack, Text } from '@mantine/core';
import React from 'react';
import { RetrieveMerchantResponse } from '../../../type/admin.types';
import { RetrievedSignatory } from '../../../type/onboard-merchant-request.types';
import { TextInfo } from '../../safe-text/safe-text.component';

interface MerchantInfoSignatoryProps {
  signatory: RetrievedSignatory;
}
function MerchantInfoSignatory(props: MerchantInfoSignatoryProps) {
  const { signatory } = props;
  const labels = {
    signatoryFirstName: 'First name',
    signatoryMiddleName: 'Middle name',
    signatoryLastName: 'Last name',
    signatoryPosition: 'Position',
  };
  return (
    <>
      <Grid>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.signatoryFirstName}
            value={signatory.firstName}
            dataCy='firstName'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.signatoryMiddleName}
            value={signatory.middleName}
            dataCy='middleName'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.signatoryLastName}
            value={signatory.lastName}
            dataCy='lastName'
          />
        </Grid.Col>
        <Grid.Col md={3} sm={6}>
          <TextInfo
            label={labels.signatoryPosition}
            value={signatory.position}
            dataCy='position'
          />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default MerchantInfoSignatory;
